export const artavaChartPalette = {
    ink: '#173042',
    navy: '#345f7c',
    copper: '#2563eb',
    copperSoft: '#8bb6ff',
    steel: '#5f7283',
    mist: '#eef4fb',
    sand: '#ffffff',
    rose: '#b42318',
    olive: '#24745f',
    warning: '#f59e0b',
    danger: '#ef4444',
    dangerDeep: '#991b1b',
    focus: 'rgba(37, 99, 235, 0.22)',
    grid: 'rgba(148, 163, 184, 0.28)',
    axis: 'rgba(100, 116, 139, 0.34)',
    tick: '#5f7283',
};

export const artavaRechartsGrid = {
    stroke: artavaChartPalette.grid,
    strokeDasharray: '3 3',
};

export const artavaRechartsAxis = {
    stroke: artavaChartPalette.axis,
    axisLine: { stroke: artavaChartPalette.axis },
    tickLine: { stroke: artavaChartPalette.axis },
    tick: { fill: artavaChartPalette.tick, fontSize: 12 },
};

export const artavaRechartsTooltip = {
    contentStyle: {
        borderRadius: 16,
        border: `1px solid ${artavaChartPalette.axis}`,
        background: 'rgba(255, 255, 255, 0.98)',
        boxShadow: '0 18px 36px rgba(15, 23, 42, 0.12)',
    },
    labelStyle: {
        color: artavaChartPalette.ink,
        fontWeight: 800,
    },
    itemStyle: {
        color: artavaChartPalette.navy,
    },
    cursor: {
        stroke: artavaChartPalette.focus,
        strokeDasharray: '4 4',
    },
};

export const artavaChartJsGridColor = artavaChartPalette.grid;
export const artavaChartJsAxisColor = artavaChartPalette.axis;
export const artavaChartJsTickColor = artavaChartPalette.tick;
export const artavaChartJsTitleColor = artavaChartPalette.ink;
export const artavaChartJsLegendColor = artavaChartPalette.navy;

export const artavaChartJsTooltip = {
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    titleColor: artavaChartPalette.ink,
    bodyColor: artavaChartPalette.navy,
    borderColor: artavaChartPalette.axis,
    borderWidth: 1,
    padding: 12,
    cornerRadius: 14,
};
